export const AB_TEST_PDP_RIGHT_RAIL = 'SS_YMAL';
export const AB_TEST_PDP_ALSO_BOUGHTWITH_TRAY = 'SS_BOUGHTWITH';
export const AB_AFTERPAY = 'SS_AFTERPAY';

// TODO: UW-14895 - remove when SS_PDPTILETYPE test is over
export const AB_PDPTILETYPE = 'SS_PDPTILETYPE';

// Sticky Email Signup Test
// SS_STICKY = unset or "0" : Serve normal modal email signup.
// SS_STICKY = "1" : Serve user sticky email signup experience rather than modal.
// SS_STICKY = "2" : No email signup experience should be loaded.
export const AB_STICKY = "SS_STICKY";

// TODO: UW-15081 - remove when SS_REC3 test is over
export const AB_REC3 = "SS_REC3";
